
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payroll",
      function () {
        return require("private-next-pages/payroll.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payroll"])
      });
    }
  